import { useQuery } from "@tanstack/react-query";
import { getProcessingShipments } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

export const useProcessingShipments = (filters) => {

  return useQuery({
    queryKey: shipmentKeys.lists(filters),

    queryFn: () => getProcessingShipments(filters),

    enabled: !!filters.warehouse,
    keepPreviousData: true,

    staleTime: 1000 * 30,
  });

};
